import { Component, inject, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { NavigationEnd, NavigationStart, Router } from '@angular/router';
import { MenuItem, MessageService } from 'primeng/api';
import { PrimeNG } from 'primeng/config';
import { filter, take, tap } from 'rxjs';
import { PostHogService } from 'src/app/shared/services/posthog.service';
import { AuthService } from './auth/components/services/auth.service';
import { ToasterService } from './shared/services/toaster.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false,
})
export class AppComponent implements OnInit {
    sidebarVisible = false;

    items: MenuItem[] = [
        {
            routerLink: ['products'],
            command: () => {
                this.sidebarVisible = false;
            },
            label: 'المنتجات',
        },
        {
            routerLink: ['pos'],
            command: () => {
                this.sidebarVisible = false;
            },
            label: 'الكاشير',
        },
        {
            routerLink: ['invoices'],
            command: () => {
                this.sidebarVisible = false;
            },
            label: 'الفواتير',
        },
    ];
    value: string;
    private posthog = inject(PostHogService);
    constructor(
        private title: Title,
        public authService: AuthService,
        private router: Router,
        private primengConfig: PrimeNG,
        private readonly toasterService: ToasterService,
        private readonly messageService: MessageService,
    ) {
        this.title.setTitle('Sellr');
        this.validateToken();
    }

    ngOnInit() {
        this.primengConfig.ripple.set(true);
        this.listenToNavigationChanges();
        this.listenToToasterMessages();
        this.router.events
            .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
            .subscribe((event) => {
                this.posthog.capture('$pageview', {
                    $current_url: event.urlAfterRedirects,
                });
            });
    }

    validateToken(): void {
        this.authService
            .getAccessToken()
            .pipe(
                take(1),
                tap((token) => {
                    if (token) {
                        // Only fetch user info if we have a valid token
                        this.authService.$isAuthenticated.set(!!token);
                        this.getUserInfo();
                    }
                    // Don't redirect here - let the guards handle routing
                }),
            )
            .subscribe();
    }

    getUserInfo(): void {
        this.authService.me.pipe(take(1)).subscribe();
    }

    listenToNavigationChanges(): void {
        this.router.events
            .pipe(
                filter((event) => event instanceof NavigationStart || event instanceof NavigationEnd),
                tap((event) => {
                    if (event instanceof NavigationStart) {
                        this.authService.runApplicationLoader.next(true);
                    }
                }),
            )
            .subscribe();
    }

    listenToToasterMessages(): void {
        this.toasterService
            .getToastMessage()
            .pipe(
                tap((message) => {
                    if (message) {
                        this.messageService.add({ severity: message.type, detail: message.message });
                    }
                }),
            )
            .subscribe();
    }
}
